module.exports = __webpack_public_path__ + "static/media/sds.adf0fb1f.png";